module.exports = __webpack_public_path__ + "static/media/DABIE_create_business_profile.c75fca82.svg";